import { render, staticRenderFns } from "./customerTransfer.vue?vue&type=template&id=777577c4&scoped=true&"
import script from "./customerTransfer.vue?vue&type=script&lang=js&"
export * from "./customerTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777577c4",
  null
  
)

export default component.exports